import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { localize } from "@webapp/localization/utils/localization.utils";

/**
 * @example <deadline-label [deadline]="metric.deadline"></deadline-label>
 *
 * @param deadline string
 * @param showNotUpdatedInsteadOfOverdue boolean - `false` will show "Overdue", if `true` will show "Not updated yet" if the deadline is overdue
 */
@Component({
  selector: "deadline-label",
  templateUrl: "./deadline-label.component.html",
  styleUrls: ["./deadline-label.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeadlineLabelComponent implements OnInit, OnChanges {
  @Input() public deadline: string;
  @Input() public showNotUpdatedInsteadOfOverdue = false;

  public text: string;
  public ariaLabel: string;

  public ngOnInit(): void {
    this.setTextToShow({ deadline: this.deadline, showNotUpdatedInsteadOfOverdue: this.showNotUpdatedInsteadOfOverdue });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const deadline = changes.deadline?.currentValue || this.deadline;
    const showNotUpdatedInsteadOfOverdue = changes.showNotUpdatedInsteadOfOverdue?.currentValue || this.showNotUpdatedInsteadOfOverdue;

    this.setTextToShow({ deadline, showNotUpdatedInsteadOfOverdue });
  }

  private setTextToShow({ deadline, showNotUpdatedInsteadOfOverdue }: { deadline: string; showNotUpdatedInsteadOfOverdue: boolean }): void {
    const overdueValue = "overdue";

    if (deadline === overdueValue) {
      if (showNotUpdatedInsteadOfOverdue) {
        this.text = localize("not_updated_yet");
      } else {
        this.text = localize("overdue");
      }

      this.ariaLabel = this.text;
    } else {
      this.text = deadline;

      if (showNotUpdatedInsteadOfOverdue) {
        this.ariaLabel = `${localize("last_updated")}: ${this.text}.`;
      } else {
        this.ariaLabel = `${localize("due")}: ${this.text}.`;
      }
    }
  }
}
